import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { FullScreenLoader } from '@/components/ui/spinner'
import { useAuthStore } from '@/features/auth/authStore'
import { useCurrentUser } from '@/features/auth/hooks/useCurrentUser'

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const status = useCurrentUser()
  const location = useLocation()
  const authStatus = useAuthStore((s) => s.status)

  if (status === 'unknown' || authStatus === 'unknown') {
    return <FullScreenLoader />
  }

  if (authStatus !== 'authenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
